import { lazy } from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = lazy(() => import('../pages/RootPage'))
const TicketListPage = lazy(() => import('../pages/TicketListPage'))
const InsightsTab = lazy(() => import('../pages/InsightsTab'))

export const ticketingRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.ticketing.path,
      element: <RootPage />,
      handle: {
        module: 'ai_ticketing',
        meta: () => {
          const basePath = navigation.ticketing.fullPath()

          const subNavigation = [
            {
              id: 'tickets',
              title: i18n.t('ticketing.inbox.tab_tickets'),
              index: true,
              href: `${basePath}`,
              isVisible: true,
            },
            {
              id: 'insights',
              title: i18n.t('ticketing.inbox.tab_insights'),
              href: basePath + '/insights',
              isVisible: true,
            },
          ]

          return {
            title: i18n.t('ticketing.inbox.title'),
            description: i18n.t('ticketing.inbox.title'),
            subNavigation,
          }
        },
      },
      children: [
        {
          id: 'tickets',
          path: '',
          element: <TicketListPage />,
        },
        {
          id: 'insights',
          path: 'insights',
          element: <InsightsTab />,
        },
      ],
    },
  ]
}
